// Frans (fr-FR), remindersApp: zelfde vorm als remindersApp.nl.ts. Tu-vorm, korte zinnen.
export const appRemindersFr = {
    section: 'Rappels',
    sectionHint: 'Un petit signal en plus sur la tablette : l’écran appelle ton enfant par son prénom, avec une grande image. Avec une liste à cocher de ce qu’il faut emporter.',
    allDayHint: 'Les rappels fonctionnent pour les événements avec une heure.',
    add: 'Rappel',
    addTitle: 'Nouveau rappel',
    editTitle: 'Modifier le rappel',
    edit: 'Modifier',
    remove: 'Retirer',
    removed: 'Rappel retiré',
    confirmAdd: 'Ajouter le rappel',
    confirmSave: 'Mettre à jour le rappel',
    closeForm: 'Fermer le formulaire sans ce rappel',
    max: '5 rappels au maximum par événement.',
    when: 'Quand',
    customWhen: 'Autre durée',
    customLabel: 'Minutes avant',
    customHint: 'De 1 à 1440 minutes (un jour).',
    offsetInvalid: 'Choisis entre 1 et 1440 minutes.',
    text: 'Texte',
    textPlaceholder: 'Se préparer pour l’entraînement',
    textRequired: 'Écris un texte court.',
    textTooLong: '60 caractères au maximum.',
    suggestions: 'Propositions',
    picto: 'Pictogramme',
    forWho: 'Pour qui',
    everyone: 'Tous ceux de l’événement',
    everyoneKids: 'Tous les enfants',
    whoRequired: 'Choisis pour qui est ce rappel.',
    prunedChanged: '{names} ne participe plus ; le rappel « {title} » a été adapté.',
    prunedChangedMany: '{names} ne participent plus ; le rappel « {title} » a été adapté.',
    prunedRemoved: '{names} ne participe plus ; le rappel « {title} » a été retiré.',
    prunedRemovedMany: '{names} ne participent plus ; le rappel « {title} » a été retiré.',
    prunedThisHint: 'Si tu choisis « Seulement cette fois » en enregistrant, les rappels des autres fois restent tels quels.',
    allDayDrop: 'Pour une journée entière, la tablette n’appelle pas : ces rappels disparaissent quand tu enregistres.',
    and: 'et',
    speak: 'Lire à voix haute',
    speakHint: 'La tablette dit le prénom et le texte à voix haute.',
    sound: 'Son',
    soundHint: 'Une petite sonnerie douce (pas pendant les heures calmes).',
    preview: 'Voici comment la tablette appelle',
    previewOk: 'OK',
    previewContext: '{title} à {time}',
    previewNoTitle: 'Événement',
    minutes: '{count} min',
    hours: '{count} h',
    hoursMinutes: '{hours} h {minutes} min',
    before: '{when} avant',
    chip: '{when} avant · {title}',
    chipLabel: 'Rappel {when} avant : {title}',
    skipOnce: 'Pas cette fois',
    skipOnceLabel: 'Rappel « {title} » : pas cette fois',
    skipOnceDone: 'Cette fois, la tablette n’appelle pas : {title}',
    skippedChip: 'Pas cette fois',
    unskip: 'Appeler quand même',
    unskipLabel: 'Rappel « {title} » : appeler quand même cette fois',
    unskipDone: 'Cette fois, la tablette appelle de nouveau : {title}',
    suggestTraining: 'Se préparer pour l’entraînement',
    suggestSwim: 'Préparer le sac de piscine',
    suggestBag: 'Préparer le sac',
    suggestShoes: 'Chaussures et manteau',
    suggestGeneric: 'Se préparer pour {title}',
    suggestGenericEmpty: 'Se préparer',
    taskTime: 'Heure',
    taskTimeHint: 'Peut rester vide.',
    taskAnnounce: 'Annoncer sur le tableau',
    taskAnnounceHint: 'À cette heure, la tablette sonne et dit qui doit faire quoi. Silencieuse pendant les heures calmes et la nuit.',
};
//# sourceMappingURL=remindersApp.fr.js.map